<template>
	<div v-if="pagebug" v-wechat-title="subject">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              ref="my_scroller"

    >
      <div class="list" v-if="list && list.length">
        <community-detail-item class="listitem" v-for="(item, index) of list" :detailItem="item" :index="index" :key="index" @detailItemHandle="detailItemHandle" :markPointData="{scenepoint: markPointData.scenepoint ? markPointData.scenepoint : 'COMMUNITYISSUES', scenedesc: item.itemid}"></community-detail-item>
      </div>
    </Scroller>
    <div v-if="list.length <= 0 && empty" class="emptybox" :style="{'height': emptyHeight/100 + 'rem', 'padding': '0.1rem 0.11rem'}">
      <empty v-if="empty" :path="'noIntegral'" :noDatades="4"></empty>
    </div>
    <div class="homeBtn">
      <div style="position:relative;height: 0.55rem;">
        <img class="release1" src="/static/images/community/release1.gif" @click="goRelease">
        <img class="release1" src="/static/images/community/release1.png" @click="goRelease">
      </div>
      <div class="floatBtn_new" style="position: static">
        <img v-if="newperson && newperson.isnewpersontask" @click="newpersontask" src="/static/images/new-person/newpersontask@2x.png">
      </div>
    </div>
  </div>
</template>

<script>
// import communityHeader from '../common/communityHeader'
import { isWeixin, fenxiang, Base64 } from '../../assets/common/js/config'
import communityDetailItem from '../common/communityDetailItem'
import Scroller from '../common/Scroller'
import empty from '../emptypage/empty'
export default {
  name: 'communityFollow',
  props: {
    markPointData: { // 埋点用
      type: Object,
      default: function () {
        return {}
      }
    },
    type: {
      type: String,
      default: ''
    },
    newperson: Object
  },
  data () {
    return {
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      list: [],
      subjectid: '',
      empty: false,
      emptyHeight: 0,
      subject: '',
      pagebug: false
    }
  },
  components: {
    // communityHeader,
    Scroller,
    communityDetailItem,
    empty
  },
  mounted () {
    this.pagebug = true
    this.$nextTick(() => {
      setTimeout(() => {
        this.emptyHeight = document.body.clientHeight
      }, 0)
    })
  },
  beforeRouteEnter (to, from, next) {
    if (from.path == '/' && from.name != 'homePage') { // 当前页面刷新不需要切换位置
      next(vm => {
        // if (isWeixin() && vm.type != 'comp') fenxiang({path: 'communitycenter'})
        vm.refresh = false
        vm.loading = false
        vm.finished = false
        vm.empty = false
        vm.subjectid = vm.$route.query.subjectid ? vm.$route.query.subjectid : ''
        vm.subject = vm.$route.meta.title = vm.$route.query.subject ? ('#' + decodeURIComponent(vm.$route.query.subject)) : ''
        vm.nowPage = 0
        vm.list = []
      })
    } else {
      next(vm => {
        // if (isWeixin() && vm.type != 'comp') fenxiang({path: 'communitycenter'})
        vm.refresh = false
        vm.loading = false
        vm.finished = false
        vm.empty = false
        vm.subjectid = vm.$route.query.subjectid ? vm.$route.query.subjectid : ''
        vm.subject = vm.$route.meta.title = vm.$route.query.subject ? ('#' + decodeURIComponent(vm.$route.query.subject)) : ''
        vm.currentIndex = vm.$store.state.communityTab
        vm.nowPage = 0
        vm.list = []
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    this.loading = true
    next()
  },
  methods: {
    getData: function () {
      let url = 'Wxmall/Community/getFollowPosts?pageno=' + this.nowPage + '&pagesize=' + this.pagesize
      if (this.subjectid) {
        url = 'Wxmall/CommunityPosts/getTopicPosts?pageno=' + this.nowPage + '&pagesize=' + this.pagesize + '&subjectid=' + this.subjectid
        url += '&fromway=' + (this.$route.query.shareOpenid ? 2 : 1)
      }
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          if (this.nowPage == 1) {
            if (this.subjectid) {
              if (isWeixin() && this.type != 'comp') {
                var base = new Base64()
                fenxiang({
                  path: 'communityfollow',
                  title: encodeURIComponent(res.data.sharetitle),
                  desc: encodeURIComponent(res.data.sharedesc),
                  imgx: res.data.shareimg,
                  dataStr: 'type=topiclist&params=' + base.encode(JSON.stringify({subjectid: this.subjectid, subject: this.$route.query.subject}))
                })
              }
              this.$clickburiedPoint({
                data: {
                  buttonCode: 'topic-' + this.subjectid
                },
                url: 'community/userbehavior/save'
              })
            }
            this.list = []
            this.refresh = false
          }
          this.list = this.list.concat(res.data.list)
          console.log(this.list)
          this.loading = false
          this.finished = res.data.list.length < this.pagesize
          if (this.nowPage == 1 && res.data.list.length == 0) this.empty = true
        }
      })
    },
    newpersontask () {
      window.location = this.newperson.newpersonjump
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      this.nowPage++
      this.getData()
    },
    goRelease: function () {
      var that = this
      // 登录校验
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$store.commit('PATH_VALUE', JSON.stringify({id: this.$route.query.id}))
          this.$router.push({
            path: '/login',
            query: {
              routeval: 'communitydetail'
            }
          })
        } else {
          f()
        }
      } else {
        f()
      }
      function f () {
        that.$clickburiedPoint({
          data: {
            buttonCode: 'posted'
          },
          url: 'community/userbehavior/save'
        })
        that.$router.push({
          path: '/communityevaluation'
        })
      }
    },
    detailItemHandle (item, index) {
      this.list.splice(index, 1, item)
    }
  }
}
</script>

<style scoped lang="scss">
.list {
  margin: 0.1rem 0.11rem;
  .listitem {
    margin-top: 0.1rem;
    &:first-child {
      margin-top: 0;
    }
  }
}
.homeBtn {
  position: fixed;
  right: 0.16rem;
  bottom: 1.55rem;
  img {
    height: 0.55rem;
    margin-top: 0.1rem;
  }
  .release1 {
    position: absolute;
    right: 0;
    width: auto;
    bottom: 0;
    height: 0.55rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community/communityFollow.vue